var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 7.33333C2.06971 7.33333 2.66667 6.73638 2.66667 6C2.66667 5.26362 2.06971 4.66667 1.33333 4.66667C0.596954 4.66667 0 5.26362 0 6C0 6.73638 0.596954 7.33333 1.33333 7.33333Z",
    fill: "#4C545B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 2.66667C2.06971 2.66667 2.66667 2.06971 2.66667 1.33333C2.66667 0.596954 2.06971 0 1.33333 0C0.596954 0 0 0.596954 0 1.33333C0 2.06971 0.596954 2.66667 1.33333 2.66667Z",
    fill: "#4C545B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 12C2.06971 12 2.66667 11.403 2.66667 10.6667C2.66667 9.93029 2.06971 9.33333 1.33333 9.33333C0.596954 9.33333 0 9.93029 0 10.6667C0 11.403 0.596954 12 1.33333 12Z",
    fill: "#4C545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotIcon);
export default __webpack_public_path__ + "static/media/3_dot_Icon.610aa2474827dd25e1a39592a96616e0.svg";
export { ForwardRef as ReactComponent };